import { fetchApi } from '@/services/api-client';

export const TRANSLATION_SETTINGS_PATH = '/translation-settings';
export const TRANSLATE_PATH = '/translate';

export type TranslationStatus = {
  configured: boolean;
};

// Never includes the (encrypted) key itself — just whether one is stored.
export type TranslationSettingsView = {
  hasKey: boolean;
  enabled: boolean;
  updatedAt: string | null;
};

export type TranslateFormat = 'text' | 'html';

export type TranslateRequest = {
  texts: string[];
  targetLang: string;
  sourceLang?: string;
  format?: TranslateFormat;
};

export type TranslateResult = {
  translations: string[];
};

export const translationApi = {
  getStatus: () => fetchApi<TranslationStatus>(`${TRANSLATION_SETTINGS_PATH}/status`),

  getSettings: () => fetchApi<TranslationSettingsView>(TRANSLATION_SETTINGS_PATH),

  setKey: (apiKey: string) =>
    fetchApi<{ ok: true }>(`${TRANSLATION_SETTINGS_PATH}/key`, {
      method: 'PUT',
      body: JSON.stringify({ apiKey }),
    }),

  clearKey: () => fetchApi<{ ok: true }>(`${TRANSLATION_SETTINGS_PATH}/key`, { method: 'DELETE' }),

  setEnabled: (enabled: boolean) =>
    fetchApi<{ ok: true }>(`${TRANSLATION_SETTINGS_PATH}/enabled`, {
      method: 'PUT',
      body: JSON.stringify({ enabled }),
    }),

  translate: (payload: TranslateRequest) =>
    fetchApi<TranslateResult>(TRANSLATE_PATH, { method: 'POST', body: JSON.stringify(payload) }),
};
